import React from "react";
import { useSelector } from "react-redux";
import { Wrapper, MessageContainer } from "../../styled";
import ErrorIcon from "../../../Icons/ErrorIcon";
import { message } from "../../../../../store/General/selectors";

const ErrorAlert = () => {
  const resultMessage = useSelector(message);
  return (
    <Wrapper>
      <ErrorIcon />
      <MessageContainer>{resultMessage}</MessageContainer>
    </Wrapper>
  );
};

export default ErrorAlert;
